const APPLE_APP_STORE_URL = "https://apps.apple.com/si/app/saddle-addict/id1589658144";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.relevateapp";

// Android gets its own link/copy since the app is free there (no paid trial).
// Anything else (iOS, macOS, or undetectable) falls back to the Apple App Store.
export function isAndroid() {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || navigator.vendor || "";
    return /android/i.test(ua);
}

export function getAppStoreUrl() {
    return isAndroid() ? GOOGLE_PLAY_URL : APPLE_APP_STORE_URL;
}

export function getAppCta() {
    return isAndroid() ? "GET THE APP" : "GET FREE MONTH";
}
